import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { PanelsService } from "@app/core/panels";

export const panelResolver: ResolveFn<any> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(PanelsService).getPanelById(+route.paramMap.get('id'));
  };